import { useMutation } from 'react-query'
import { useDealership } from '../../../store/zustand/dealershipStore'
import { useBuildQueryParams } from '../../../lib/hooks/useBuildQueryParams'

export const useDownloadPDFReport = (viewportSize?: {
  width: number
  height: number
}) => {
  const dealership = useDealership()
  const queryParams = viewportSize
    ? `?width=${viewportSize.width}&height=${viewportSize.height}`
    : ''

  return useMutation(() =>
    fetch(
      `${import.meta.env.VITE_API_URL}/agencies/${
        dealership?.organization_id
      }/dealership/${dealership?.id}/reports/download${queryParams}`,
      {
        method: 'GET',
        credentials: 'include',
        referrerPolicy: 'unsafe-url',
        headers: {
          'X-Org-Id': String(dealership?.organization_id),
        },
      },
    ),
  )
}
